import type { JSX } from 'solid-js';
import { AuditFeedList } from '../components/AuditFeedList';
import { LoadMore } from '../components/LoadMore';
import { PageHeader } from '../components/PageHeader';
import { Panel } from '../components/Panel';
import { QueryBoundary } from '../components/QueryBoundary';
import { Skeleton } from '../components/Skeleton';
import { t } from '../i18n';
import { type AuditFeedEvent, useAuditFeed } from '../lib/audit-feed';
import { usePagedQuery } from '../lib/paged';
import { SESSION_TOKEN } from '../lib/session';

// Account audit log (#854): the Home "Live audit" panel's View-all target —
// every maintainer-visible audit event across the account's sessions, newest
// first, off `GET /v1/audit/events`. Container — paging is `lib/paged` (same
// shape as the repo Audit tab); each row links into the full
// /audit/:session_id timeline.

export function AccountAudit(props: { token?: string | null } = {}): JSX.Element {
  // Default to the dev session ONLY when the prop is omitted — an explicit
  // `null` is a signed-out caller (`??` would wrongly replace it).
  const token = props.token === undefined ? SESSION_TOKEN : props.token;
  const list = usePagedQuery<AuditFeedEvent>((cursor) => useAuditFeed(cursor, token));

  return (
    <>
      <PageHeader title={t('audit.title')} desc={t('audit.subtitle')} />
      <Panel title={t('audit.events')}>
        <QueryBoundary
          query={list.view}
          isEmpty={(r) => r.length === 0}
          loading={<Skeleton height="14rem" />}
          empty={<p class="list-empty">{t('audit.empty')}</p>}
        >
          {(r) => (
            <>
              <AuditFeedList events={r} />
              <LoadMore list={list} label={t('audit.load_more')} />
            </>
          )}
        </QueryBoundary>
      </Panel>
    </>
  );
}
